import { addDays, format, startOfDay, subDays } from 'date-fns';
import type { TimeRange } from './types';

export const getDateRangeFromTimeRange = (timeRange: TimeRange): { date_from: string; date_to: string } => {
  const now = new Date();
  // date_to is exclusive — use start of tomorrow so today is included
  const date_to = format(addDays(startOfDay(now), 1), 'yyyy-MM-dd');

  switch (timeRange) {
    case 'today':
      return { date_from: format(startOfDay(now), 'yyyy-MM-dd'), date_to };
    case 'last_7_days':
      return { date_from: format(subDays(startOfDay(now), 6), 'yyyy-MM-dd'), date_to };
    case 'last_30_days':
      return { date_from: format(subDays(startOfDay(now), 29), 'yyyy-MM-dd'), date_to };
    default:
      return { date_from: format(startOfDay(now), 'yyyy-MM-dd'), date_to };
  }
};
